/* eslint-disable */
export default async function ({ store, $config }) {
  if (!store.state.cacheVersion) {
    await store.dispatch('loadCacheVersion', { version: $config.dev ? 'draft' : 'published' })
  }
}
